// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2eb8C","header":"ReportDetails_header__2z36r","title":"ReportDetails_title__10_3Z","left":"ReportDetails_left__2ussb"};